import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.6",
  viewBox: "0 0 30 30"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<path d=\"M4 4v21.5h22\"></path><rect width=\"4\" height=\"12.5\" x=\"7.5\" y=\"9\" rx=\".75\"></rect><path d=\"M7.5 15h4\"></path><rect width=\"4\" height=\"15\" x=\"14\" y=\"6.5\" rx=\".75\"></rect><path d=\"M14 10h4\"></path><rect width=\"4\" height=\"10.5\" x=\"20.5\" y=\"11\" rx=\".75\"></rect><path d=\"M20.5 18h4\"></path>", 7)
  ]))]))
}
export default { render: render }